import { ActionTypes } from "../constants/action-types";
import { createAction } from "redux-actions";
import { getAttributes, getTemplates } from "../api/TemplateApi";

const api = {
  [ActionTypes.getTemplates]: () => getTemplates(),
  [ActionTypes.getAttributes]: (contexts: string[]) => getAttributes(contexts),
};

const actions: any = { ...api };

Object.keys(actions).forEach((type) => {
  actions[type] = createAction(type, actions[type]);
});

export default actions;
